export default "__VITE_ASSET__2v3OHw7T__"